import Vue from "vue";
import App from "./App";
import router from "./router";
import cognito from "./plugins/cognito";
import store from "./store";
import VueScrollTo from "./plugins/vueScrollTo";
import Pagination from "./plugins/pagination";

import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";

import "babel-polyfill";
import "normalize.css";

import smoothScroll from "smoothscroll-polyfill";
smoothScroll.polyfill();

Vue.use(Pagination);
Vue.use(Vuetify);

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== "production";

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  cognito,
  store,
  VueScrollTo,
  Pagination,
  vuetify: new Vuetify(),
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js